/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * エージェント契約情報
 * @export
 * @interface GetAccount200ResponseAgent
 */
export interface GetAccount200ResponseAgent {
    /**
     * エージェント契約有無
     * @type {boolean}
     * @memberof GetAccount200ResponseAgent
     */
    isUsingAgent: boolean;
    /**
     * エージェント開始日(YYYY-MM-DD)
     * @type {string}
     * @memberof GetAccount200ResponseAgent
     */
    agentStartDate: string;
    /**
     * エージェント週(YYYY-MM-DD)
     * @type {string}
     * @memberof GetAccount200ResponseAgent
     */
    agentEndDate: string;
}

/**
 * Check if a given object implements the GetAccount200ResponseAgent interface.
 */
export function instanceOfGetAccount200ResponseAgent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isUsingAgent" in value;
    isInstance = isInstance && "agentStartDate" in value;
    isInstance = isInstance && "agentEndDate" in value;

    return isInstance;
}

export function GetAccount200ResponseAgentFromJSON(json: any): GetAccount200ResponseAgent {
    return GetAccount200ResponseAgentFromJSONTyped(json, false);
}

export function GetAccount200ResponseAgentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccount200ResponseAgent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isUsingAgent': json['is_using_agent'],
        'agentStartDate': json['agent_start_date'],
        'agentEndDate': json['agent_end_date'],
    };
}

export function GetAccount200ResponseAgentToJSON(value?: GetAccount200ResponseAgent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_using_agent': value.isUsingAgent,
        'agent_start_date': value.agentStartDate,
        'agent_end_date': value.agentEndDate,
    };
}

